"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/types");
var _utils = require("../../utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function overlays() {
  var _payload$overlays;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case "".concat(_types.GET_BROADCAST, "_SUCCESS"):
    case "".concat(_types.SYNC_OVERLAYS, "_SUCCESS"):
    case "".concat(_types.UPDATE_OVERLAYS, "_SUCCESS"):
    case "".concat(_types.BROADCAST_SYNC_LAYER_SOURCES, "_SUCCESS"):
      return payload.overlays;
    case "".concat(_types.BROADCAST_SET_PROGRAM, "_SUCCESS"):
      if ((payload === null || payload === void 0 || (_payload$overlays = payload.overlays) === null || _payload$overlays === void 0 ? void 0 : _payload$overlays.length) > 0) {
        return payload.overlays;
      }
      return state;
    case "".concat(_types.BROADCAST_UPLOAD_OVERLAY, "_SUCCESS"):
    case "".concat(_types.BROADCAST_CREATE_OVERLAY, "_SUCCESS"):
      return [].concat(_toConsumableArray(state), _toConsumableArray(payload));
    case "".concat(_types.BROADCAST_DELETE_OVERLAY, "_SUCCESS"):
    case _types.BROADCAST_DELETE_OVERLAY:
      return state.filter(function (overlay) {
        return overlay._id !== payload;
      });
    case "".concat(_types.BROADCAST_TOGGLE_OVERLAY_HIDDEN, "_SUCCESS"):
      return (0, _utils.toggleOverlayStatus)(payload, state);
    case _types.BROADCAST_TOGGLE_OVERLAY_STATUS:
      return payload;
    case "".concat(_types.BROADCAST_UPDATE_OVERLAY_STATE, "_SUCCESS"):
      var updatedOverlay = _toConsumableArray(state).map(function (overlay) {
        if (overlay._id === payload._id) {
          return _objectSpread(_objectSpread({}, overlay), {}, {
            source: payload.source
          });
        }
        return overlay;
      });
      return updatedOverlay;
    case "".concat(_types.BROADCAST_UPDATE_OVERLAY_POSITION, "_SUCCESS"):
      var updatedState = _toConsumableArray(state).map(function (overlay) {
        if (overlay._id === payload._id) {
          return _objectSpread(_objectSpread({}, overlay), {}, {
            layer: payload.layer
          });
        }
        return overlay;
      });
      return updatedState;
    default:
      return state;
  }
}
var _default = exports["default"] = overlays;